import { EnumOption } from './enum-option';

export enum SortDirection {
  Asc = 0,
  Desc = 1,
}

export const SortDirectionOptions: EnumOption[] = [
  { label: 'Ascending', value: SortDirection.Asc },
  { label: 'Descending', value: SortDirection.Desc },
];
